define('plugin/package/view/PackageInstanceEmptyView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Package empty view
     *
     * @class PackageInstanceEmptyView
     */
    return LayoutView.extend({

        template: '#package_instance_empty_view',
    });

});
